/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component, createRef } from 'react';
import moment from 'moment';
import * as momentTz from 'moment-timezone';

// project imports
import Datatable from 'shared/datatable';
import { adminContentList, newsAndStoriesUpdate } from 'shared/settings/apiconfig';

// style imports
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import axios from 'axios';
import { getAdminHeaders, getAdminUrl } from 'shared/http';

/**
 * this page is used to list news and stories
 * 
 * @param props
 * 
 * @returns html code to render the news and stories list
 * 
**/

export class NewsAndStoriesList extends Component {

    config;

    constructor(props) {
        super(props);

        this.dataTable = createRef();

        /* initial search state */
        this.initialSearchState = {
            title: { field: 'title', value: '', op: 'LIKE', join: 'AND' },
            status: { field: 'status', value: '', op: "=", join: "AND" }
        }

        this.state = {
            search: this.initialSearchState,
            searchData: true,
            locations: [],
            pageLoading: false,
            tableData: [],
            storiesDeleteModal: false,
            deleteData: {},
            deleteMsg: {type: '', msg: ''}
        };

        this.config = {
            name: "newsandstories",
            url: adminContentList,
            adminUrl: {},
            params: {},
            columns: [
                {
                    name: '', property: 'id', columnType: 'actions', actions: ['view', 'edit', 'delete'], customHeader: <></>, width: '75px',
                    actionEvents: { 
                        view: (row) => { this.moveToContent(row) },
                        edit: (row, state) => {
                            let data = {}
                            data['datatable'] = this.state.tableData.stateData;
                            data['PageSize'] = this.state.PageSize;
                            this.props.history.push({ pathname: `/ctbids-content/news-and-stories/edit/${row.id}`, state: state}) },
                        delete: (row) => { this.deleteStories(row) }
                    }
                },
                { name: 'Title', property: 'title', width: '220px' },
                { name: 'Status', property: 'status', width: '220px', columnType: 'custom', customColumn: this.customStatus },
                { name: 'Author', property: 'publishername', width: '100px' },
                { name: 'Effective Date', property: 'effectivedate', width: "200px", columnType: 'custom', sortType: 'date', customColumn: this.customEffectiveDate },
                { name: 'Last Modified', property: 'updatedDate', width: '250px', columnType: 'custom', sortType: 'date', customColumn: this.customDate }
            ],
            pagination: true,
            field: [],
            sort: [{ "field": "effectivedate", "direction": "desc" }],
        };
        if (props.location.state && props.location.state.datatable && props.location.state.datatable.search) {
            let tempSearch = { ...this.initialSearchState };
            const search = [...props.location.state.datatable.search];

            search.forEach(element => {
                let temp = { ...element };
                if (typeof temp['value'] === 'string') {
                    temp['value'] = temp['value'].replace(/(^\*)|(\*$)/g, '');
                }
                if (temp['field'] === 'createddate') {
                    temp['value'] = new Date(temp['value']);
                }
                if (temp['field'] === 'createddate' && temp['op'] === '<=') {
                    temp['field'] = 'todate';
                }
                if (temp['field'] === 'createddate' && temp['op'] === '>=') {
                    temp['field'] = 'fromdate';
                }
                tempSearch[temp['field']] = temp;
            });

            this.state['search'] = tempSearch;
            this.state['issearch'] = Boolean(search.length);
            this.state['searchData'] = true;
        }

        this.dataTable = createRef();
    }

    componentDidMount() {
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        // this.enableSearch();
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            e.stopPropagation();
            this.enableSearch()
            return false;
        }
    }

    moveToContent = (row) => {
        this.props.history.push({ pathname: `/ctbids-content/news-and-stories/view/${row.id}`});
    }

    onBack = (e) => {
        e.preventDefault();
        window.history.pushState(null, null, window.location.pathname);
    }

    customStatus = (value) => {
        return value.status.charAt(0).toUpperCase() + value.status.slice(1);
    }

    customDate = (value) => {
        if (value['updatedDate']) {
            return `${moment.utc(value['updatedDate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    };

    customEffectiveDate = (value) => {
        if (value['effectivedate']) {
            return `${moment.utc(value['effectivedate']).local().format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
        }
        return '- - -';
    }

    deleteStories = (row) => {
        this.setState({
            storiesDeleteModal: true,
            deleteData: row
        })
    }

    /* called when search input changes */
    searchInputChange = (event) => {
        let eventValue = event.target.value;
        this.setState({
            ...this.state,
            search: {
                ...this.state.search,
                [event.target.name]: {
                    ...this.state.search[event.target.name],
                    value: eventValue
                }
            },
            searchData: true
        });
    }

    /* called when clear in search clicked */
    resetState = () => {
        this.setState({
            ...this.state,
            search: this.initialSearchState,
            searchData: true,
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    /* called when search button clicked */
    enableSearch = () => {
        var search = {
            title: { ...this.state.search.title },
            status: { ...this.state.search.status }
        }
        this.setState({
            search: search,
            searchData: true
        }, () => {
            this.dataTable.current.searchData();
        });
    }

    navigateTo = (type) => {
        this.props.history.push({pathname: "/ctbids-content/news-and-stories/add", state: {type}})
    }

    removeStories = (row) => {
        let data = {
            "data": {
                id: row.id,
                status: "deleted",
                publisheddate: row.publisheddate
            }
        }
        axios.post(getAdminUrl(newsAndStoriesUpdate), data, getAdminHeaders()).then(response => {
            if (response.data.status == "success") {
                this.enableSearch();
                this.setState({
                    storiesDeleteModal: false
                })
            }
        }).catch(error => {
            this.setState({
                deleteMsg: {tyepe: "error", msg: error.response.data.message}
            })
        })
    }

    render() {

        return (
            <div className={`${this.state.pageLoading ? 'h-100' : ''} overflow-auto`}>
                {
                    this.state.pageLoading ? <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                    </div> :
                        <div>
                            <div style={{ backgroundColor: "#FFFFFF", padding: "2%" }}>
                                <div className="sales-list-search">
                                    <h3 className='font-weight-bold'>News And Stories</h3>
                                    <div className='d-flex align-items-center justify-content-end'>
                                        <Button style={{ borderRadius: "5px", backgroundColor: "#a50050" }} onClick={() => {this.navigateTo("yourself")}}>Author Yourself</Button>
                                        <Button className="mx-3" style={{ borderRadius: "5px", backgroundColor: "#a50050" }} onClick={() => {this.navigateTo("external")}}>Create From External</Button>
                                    </div>
                                    <Form className="sales-list-font mt-3">
                                        <div className="sales-search-container">
                                            <Row md={5}>
                                                <Col>
                                                    <label>Title</label>
                                                    <Form.Control type="text" name="title" value={this.state.search.title.value} onKeyDown={(event) => this._handleKeyDown(event)} onChange={(event) => this.searchInputChange(event)} />
                                                </Col>
                                                <Col>
                                                    <label>Status</label>
                                                    <Form.Control as="select" name="status" value={this.state.search.status.value} onChange={(event) => this.searchInputChange(event)}>
                                                        <option value={""}>Status All</option>
                                                        <option value={"draft"}>Draft</option>
                                                        <option value={"published"}>Published</option>
                                                        <option value={"schedule later"}>Schedule Later</option>
                                                        <option value={"deleted"}>Deleted</option>
                                                    </Form.Control>
                                                </Col>
                                                <Col>
                                                    <div className="mt-3">
                                                        <Button className="clear-button" onClick={() => this.resetState()}>Clear All</Button>
                                                        <Button variant="seller-search" onClick={() => this.enableSearch()}>Search</Button>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div style={{ padding: "0 2%" }}>
                                <Datatable {...this.props} config={{ ...this.config }} search={this.state.searchData ? { search: { ...this.state.search }, searchData: this.state.searchData } : null} ref={this.dataTable}></Datatable>
                            </div>     
                        </div>
                }
                <Modal centered show={this.state.storiesDeleteModal} animation={false} backdrop="static" keyboard={false} onHide={() => this.setState({ storiesDeleteModal: false, deleteMsg: {type: "", msg: ''} })} style={{ height: "500px" }}>
                    <Modal.Header className='align-items-end justify-content-end clickable'>
                        <div className="close-icon" onClick={() => this.setState({ storiesDeleteModal: false, deleteMsg: {type: "", msg: ''} })}></div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='d-flex align-items-center justify-content-center'>
                            <div>Are you sure want to delete story?</div>
                        </div>
                        
                        {this.state.deleteMsg.msg ? <div className='d-flex align-items-center justify-content-center mt-3' style={{ color: "red" }}>{this.state.deleteMsg.msg}</div> : ''}

                        <div className="d-flex align-items-center justify-content-center actions mt-3">
                            <div className="d-flex align-items-center justify-content-center actions">
                                <Button variant="outline-dark btn-white mx-2" onClick={() => this.setState({ storiesDeleteModal: false, deleteMsg: {type: "", msg: ''} })}>No</Button>
                                <Button variant="secondary mx-2" onClick={() => this.removeStories(this.state.deleteData)}>Yes</Button> 
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}